import {useCallback, useEffect, useRef} from 'react'
import {Hub} from 'yougile-model'
import {useSyncEvent} from '@containers/hooks'
import {ThemeUtils} from '@extensions/theme-utils'
import {boardSettingsStore} from './board-settings/board-settings-store'
import {BoardTabBg} from './board-tab-bg'

// need when other users change bg
export const useUpdateBackground = (board: Hub): void => {
  const prevBg = useRef(getBoardBg(board))

  const refresh = useCallback(() => {
    void BoardTabBg.refresh()
    void ThemeUtils.upTheme()
    boardSettingsStore.updateBgTabModified()
  }, [])

  useEffect(() => {
    refresh()
    return refresh
  }, [board, refresh])

  useSyncEvent(
    'current',
    {filter: board?.id, debounceTime: 150},
    () => {
      const newBg = getBoardBg(board)

      if (prevBg.current !== newBg) {
        prevBg.current = newBg

        void BoardTabBg.refresh()
        void ThemeUtils.upTheme()
        boardSettingsStore.updateBgTabModified()
      }
    },
    [board]
  )

  return undefined
}

const getBoardBg = (board: Hub): string => {
  const enabled = board?.data?.tabBgEnabled
  const bg = board?.data?.tabBgSkin || ''

  return enabled ? bg : ''
}
